<template>
  <div>
    <v-head></v-head>
    <div class="success_bg">
      <img src="../assets/pic01.png" alt="">
      <div class="success_txt">
        <div class="title">
          成功案例
        </div>
        <div class="txt">
          Successful Cases
        </div>
      </div>
    </div>
    <div class="one">
      <img src="../assets/pic1.png" alt="" class="left" />
      <div class="right">
        <div class="title">基于RFID的接地线管理系统</div>
        <div class="info">
          基于物联网的变电站挂接地线管理装置的研发成果，由国网上海市电力公司市北供电公司于
2021年2月在钱湾站内进行了安装应用试验。
        </div>
        <div class="arrow"  @click="gotoMoreInfor">查看更多 →</div>
      </div>
    </div>
    <div class="one">
      <img src="../assets/pic2.png" alt="" class="left" />
      <div class="right">
        <div class="title">变电站设备音频指纹特征采集和诊断分析系统</div>
        <div class="info">
          音频处理平台在变电站巡检、远程集中监听等方面具有非常广阔的应用前景。本项目研究开
发的音频处理平台可用于变电站运行状态诊断，通过音频文件提取有用的数据和信息。
        </div>
        <div class="arrow"  @click="gotoMoreInfor1">查看更多 →</div>
      </div>
    </div>
    <div class="one">
      <img src="../assets/pic3.png" alt="" class="left" />
      <div class="right">
        <div class="title">智能运维视频辅助巡检机器人</div>
        <div class="info">
          2020年3月份-6月份在上海市市南配电站完成地面引导线铺设和一台地面式运维巡检机器人
的部署任务，并开展了为期3个月的性能调试、功能验证及优化改进工作。
        </div>
        <div class="arrow"  @click="gotoMoreInfor2">查看更多 →</div>
      </div>
    </div>
    <div class="one">
      <img src="../assets/pic4.png" alt="" class="left" />
      <div class="right">
        <div class="title">用户停电互动智能管理系统</div>
        <div class="info">
          项目针对国网上海供电公司管辖区域内的运行要求，2021年8月5日和8月6日在国网上海市
供电公司市南供电公司指定区域内进行测试。
        </div>
        <div class="arrow"  @click="gotoMoreInfor3">查看更多 →</div>
      </div>
    </div>
    <div class="one">
      <img src="../assets/pic5.png" alt="" class="left" />
      <div class="right">
        <div class="title">基于人工智能的电系操作指令票自动识别</div>
        <div class="info">
          基于人工智能的电系操作指令票的系统，该系统已于2021年6月在上海市电力公司市北供电
公司内进行了应用试验。
        </div>
        <div class="arrow"  @click="gotoMoreInfor4">查看更多 →</div>
      </div>
    </div>
    <div class="one">
      <img src="../assets/pic6.png" alt="" class="left" />
      <div class="right">
        <div class="title">基于经纬度信息的辅助室外巡检导航系统</div>
        <div class="info">
          基于经纬度信息的室外辅助巡检导航系统，由国网上海市电力公司长兴供电公司于2021年4
月在指定区域内进行实际的应用试验。
        </div>
        <div class="arrow"  @click="gotoMoreInfor5">查看更多 →</div>
      </div>
    </div>
    <div class="one">
      <img src="../assets/pic7.png" alt="" class="left" />
      <div class="right">
        <div class="title">电站无人值守自主移动巡检机器人</div>
        <div class="info">
          2020年3月份-6月份在上海市市区配电站完成导轨与机械臂的安装部署任务，并开展了为期3
个月的性能调试、功能验证及优化改进工作。
        </div>
        <div class="arrow"  @click="gotoMoreInfor6">查看更多 →</div>
      </div>
    </div>
    <div class="one">
      <img src="../assets/pic8.png" alt="" class="left" />
      <div class="right">
        <div class="title">地电波检测机械臂</div>
        <div class="info">
          无人值守巡检机器人项目成果由国网上海市电力公司市区供电公司运检部于2018年2月起在
自忠变电站配电室内部署应用。
        </div>
        <div class="arrow"  @click="gotoMoreInfor7">查看更多 →</div>
      </div>
    </div>
    <div class="one">
      <img src="../assets/pic9.png" alt="" class="left" />
      <div class="right">
        <div class="title">应用人脸识别和激光引导技术的五防安全辅助装置</div>
        <div class="info">
          “人脸识别和激光引导技术的五防安全辅助装置研制”的研究成果由国网上海市电力公司市北
供电公司于2020年1月起在钱湾站内部署应用。
        </div>
        <div class="arrow"  @click="gotoMoreInfor8">查看更多 →</div>
      </div>
    </div>
    <div class="one last">
      <img src="../assets/pic10.png" alt="" class="left" />
      <div class="right">
        <div class="title">基于物联网的设备管理平台</div>
        <div class="info">
          物联网智能集中器在配网自动化中的应用研究项目成果由国网上海市电力公司浦东供电公司
于2018年11月在浦东电站内进行了安装应用试验。
        </div>
        <div class="arrow"  @click="gotoMoreInfor9">查看更多 →</div>
      </div>
    </div>
    <div class="one last">
      <img src="../assets/jk2.png" alt="" class="left" />
      <div class="right">
        <div class="title">医疗健康分析平台</div>
        <div class="info">
          本项目充分利用业务中台支撑服务，新建设基于多源数据融合的电力企业职工健康状态的大
数据分析及预测中心管控模块，进一步提电力职工健康管理能力。
        </div>
        <div class="arrow"  @click="gotoMoreInfor10">查看更多 →</div>
      </div>
    </div>
    <v-foot></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    },
    gotoMoreInfor() {
      router.push('/moreInfor')
    },
    gotoMoreInfor1() {
      router.push('/moreInfor8')
    },
    gotoMoreInfor2() {
      router.push('/moreInfor5')
    },
    gotoMoreInfor3() {
      router.push('/moreInfor1')
    },
    gotoMoreInfor4() {
      router.push('/moreInfor2')
    },
    gotoMoreInfor5() {
      router.push('/moreInfor3')
    },
    gotoMoreInfor6() {
      router.push('/moreInfor7')
    },
    gotoMoreInfor7() {
      router.push('/moreInfor6')
    },
    gotoMoreInfor8() {
      router.push('/moreInfor9')
    },
    gotoMoreInfor9() {
      router.push('/moreInfor4')
    },
    gotoMoreInfor10() {
      router.push('/moreInfor10')
    },
  }
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.success_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.success_txt {
  position: absolute;
  top: 280px;
  right: 420px;
  color: #fff ;
}
.success_txt .title {
  font-size: 58px;
}
.success_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.one {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}
.one .left {
  width: 170px;
  height: 170px;
}
.one .right {
  margin-left: 40px;
  text-align: left;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
  width: 800px;
}
.right .title {
  font-size: 20px;
  margin-bottom: 20px;
}
.right .info {
  font-size: 15px;
  margin-bottom: 20px;
}
.right .arrow {
  background-color: #f5a93e;
  padding: 5px 0;
  color: #fff;
  width: 120px;
  height: 20px;
  font-size: 15px;
  text-align: center;
  line-height: 20px;
  border-radius: 5px;
  cursor: pointer;
}
.right .arrow:hover {
  background-color: #fa9912;
}
.last {
  margin-bottom: 80px;
}
</style>


// WEBPACK FOOTER //
// src/components/Success.vue